import { useLang } from "@/context/LanguageContext";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";

export default function FAQ() {
  const { t } = useLang();

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 md:py-32"
    >
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <span
            data-testid="faq-eyebrow"
            className="font-body text-sm uppercase tracking-widest font-bold text-[#22C55E]"
          >
            {t.faq.eyebrow}
          </span>
          <h2
            data-testid="faq-title"
            className="mt-4 font-heading text-4xl md:text-5xl font-extrabold tracking-tight text-[#064E3B] leading-[1.05]"
          >
            {t.faq.title}
          </h2>
        </div>

        <div className="mt-12 space-y-3">
          <Accordion type="single" collapsible data-testid="faq-accordion">
            {t.faq.items.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="bg-white border border-[#D1FAE5] rounded-2xl px-6 mb-3 hover:bg-[#F0FDF4]/40 transition-colors duration-300 [&_svg]:text-[#22C55E]"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="font-heading text-lg md:text-xl font-bold text-[#064E3B] py-5 hover:no-underline text-left"
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-content-${i}`}
                  className="font-body text-base text-[#047857] leading-relaxed pb-5"
                >
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
